import type { ConversationSmsRoute } from './conversation-ownership-contracts'
import type { ConversationOwnershipRepository } from './conversation-ownership-repository'
import { useAggregatePoll } from './use-aggregate-poll'
import type { HintSurface } from '../../services/dashboard-invalidation'

const SMS_ROUTE_SURFACES: readonly HintSurface[] = [
  'ownership',
  'aggregates',
  'conversations',
]

export function useConversationSmsRoute(
  repository: ConversationOwnershipRepository | undefined,
  tenantId: string,
  aggregateId: string | null
) {
  // The route is validated against its raw thread, whose notifier signals
  // the conversations surface.
  const poll = useAggregatePoll<ConversationSmsRoute>(
    repository?.getSmsRoute,
    tenantId,
    aggregateId,
    undefined,
    SMS_ROUTE_SURFACES
  )
  // Fails closed: without a current route, staff SMS reply is unavailable.
  return poll.status === 'failed'
    ? { status: 'unavailable' as const, value: null, refresh: poll.refresh }
    : { status: poll.status, value: poll.value, refresh: poll.refresh }
}
